import { action } from "typesafe-actions";
import ActionTypes from "../constants";

const landingR2D2Base = (ekind: string, edata, screen?: string) =>
  action(ActionTypes.TRACK, {
    ekind,
    okind: "tracker",
    edata: {
      screen: screen || "bike_aadrilla_success_screen",
      web_engage: true,
      ...edata
    },
    odata: {
      product: "bike",
      url: "/lp/new-bike/bike/mmv"
    }
  });

export const bikeIdentifedSuccessScreenLoads = edata =>
  landingR2D2Base("bike_identifed_success_screen_loads", { ...edata });

export const bikeMMVScreenLoaded = (reg_no, screen) =>
  landingR2D2Base("bike_mmv_screen_loaded", { reg_no }, screen);

export const bikeRegNoEditClicked = (edata, success) =>
  landingR2D2Base(
    "bike_reg_no_edit_clicked",
    {
      ...edata
    },
    success ? "bike_aadrilla_success_screen" : "bike_aadrilla_failure_screen"
  );

export const bikeRegYearEnteredClicked = (edata, screen) =>
  landingR2D2Base("bike_reg_year_entered_clicked", { ...edata }, screen);

export const bikePreviousPolicyStatusClicked = (edata, screen) =>
  landingR2D2Base("bike_previous_policy_status_clicked", { ...edata }, screen);

export const bikeAgeSelected = (edata, screen) =>
  landingR2D2Base("bike_age_selected", { ...edata }, screen);

export const bikePreviousPolicyExpirySelected = (edata, screen) =>
  landingR2D2Base("bike_previous_policy_expiry_selected", { ...edata }, screen);

export const notYourBikeClicked = (edata, success) =>
  landingR2D2Base(
    "not_your_bike_clicked",
    {
      ...edata
    },
    success ? "bike_aadrilla_success_screen" : "bike_aadrilla_failure_screen"
  );

export const viewPricesCTAClicked = (edata, screen) =>
  landingR2D2Base(
    "view_prices_cta_clicked",
    { ...edata, product_state: null },
    screen
  );

export const popularBikeSelected = (edata, screen) =>
  landingR2D2Base(
    "popular_bike_selected",
    {
      ...edata
    },
    screen
  );

export const bikeMMVIdentificationStarted = (edata, screen) =>
  landingR2D2Base("bike_mmv_identification_started", { ...edata }, screen);

export const makeModelSelected = (edata, screen) =>
  landingR2D2Base("make_model_selected", { ...edata }, screen);

export const whatsappClicked = edata =>
  landingR2D2Base("whatsapp_check_clicked", { ...edata });

export const phoneNumberEntered = edata =>
  landingR2D2Base("phone_number_entered", { ...edata, product_state: null });

export const vehicleTypeMismatch = edata =>
  landingR2D2Base("vehicle_type_mismatch_identified", {
    ...edata,
    product_state: null
  });

export const bikePrequoteScreenSkipped = edata =>
  landingR2D2Base("bike_prequote_screen_skipped", { ...edata });
